// extracted by mini-css-extract-plugin
export var blue = "_q-f";
export var brand = "_q-b";
export var darkGrey = "_q-e";
export var disabled = "_q-4";
export var disabledSubtle = "_q-5";
export var error = "_q-6";
export var green = "_q-g";
export var grey = "_q-d";
export var icon = "_q-0";
export var inherit = "_q-a";
export var lightGrey = "_q-c";
export var orange = "_q-i";
export var pink = "_q-k";
export var primary = "_q-1";
export var purple = "_q-l";
export var red = "_q-j";
export var secondary = "_q-2";
export var success = "_q-9";
export var tertiary = "_q-3";
export var warning = "_q-7";
export var warningSecondary = "_q-8";
export var white = "_q-m";
export var yellow = "_q-h";